import { GET_DELEGATES } from "../../../enums/Request/leader.requests.types";

export const getDelegates = (data) => {
    return {
        type: GET_DELEGATES,
        payload: data,
    }
}
